import { FilterData } from '@keaze/web/components/filters';

export const DEFAULT_RADIUS_VALUES = [5, 10, 15, 20, 30, 40];

export const generateSearchRadius = (): FilterData[] =>
  DEFAULT_RADIUS_VALUES.map((value) => ({
    text: `+${value} miles`,
    value,
    count: null,
  }));
